import { render, staticRenderFns } from "./prevone.vue?vue&type=template&id=8f2a7656&"
import script from "./prevone.vue?vue&type=script&lang=ts&"
export * from "./prevone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports